import {
  Button,
  Col,
  Dropdown,
  Icon,
  Input,
  InputNumber,
  Menu,
  notification,
  Row,
  Select,
  Spin,
  Switch,
  Table,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DrawerBankAccountFarm from "../../../../../../components/drawers/bankAccountFarm";
import ButtonStandard from "../../../../../../components/utils/button";
import MenuIcon from "../../../../../../components/utils/table/icons/menu";
import { Container as MenuContainer } from "../../../../../../components/utils/table/menu/styles";
import TagStatus from "../../../../../../components/utils/tagStatus";
import {
  activateBankAccountFarm,
  inactivateBankAccountFarm,
} from "../../../../../../services/bankAccountFarmService";
import {
  getParameterItems,
  saveOrUpdateParameter,
} from "../../../../../../services/generalParameterService";
import { Creators as BankAccountFarmActions } from "../../../../../../store/ducks/bankAccountFarm";
import { CardCustom, TableContainer, Title } from "./styles";
import {
  getTwoDecimalDigits,
  numberMask,
} from "../../../../../../services/helpersMethodsService";

// import { Container } from './styles';

const CODES_PARAMETERS = [4006];

function BankAccountFarm() {
  const [isLoading, setIsLoading] = useState(false);
  const [parametersValue, setParametersValue] = useState([]);
  const [parameter4006Value, setParameter4006Value] = useState(null);

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const {
    bankAccountFarmTableData: dataList,
    loadingBankAccountFarmTableData: isLoadingDataList,
  } = useSelector((state) => state.bankAccountFarm);

  const dispatch = useDispatch();

  const getParameters = useCallback(async () => {
    setIsLoading(true);
    let dataResult = [];
    try {
      for (var i = 0; i < CODES_PARAMETERS.length; i++) {
        let code = CODES_PARAMETERS[i];
        let {
          data: { results },
        } = await getParameterItems({ groupId, farmId, code });
        results.isDefault = results.farmId == null && results.groupId == null;
        results.updated = false;
        dataResult.push(results);
      }
      setParametersValue(dataResult);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [farmId, groupId]);

  const fetchData = useCallback(() => {
    dispatch(BankAccountFarmActions.getBankAccountFarm(groupId, farmId));
  }, [dispatch, farmId, groupId]);

  const handleChangeParameter4006Value = useCallback(
    async (parameter4006Value, checked) => {
      setIsLoading(true);
      try {
        const newParameter4006Value = {
          ...parameter4006Value,
          value: `${checked}`,
          updated: true,
        };
        setParameter4006Value(newParameter4006Value);
        await saveOrUpdateParameter({
          groupId,
          farmId,
          parameterItemId: newParameter4006Value.id,
          parameterId: newParameter4006Value.parameterId,
          edit: !newParameter4006Value.isDefault,
          body: newParameter4006Value,
        });
        notification.success({
          message: translation.generalParameters.successParameterUpdated,
        });
        getParameters();
      } catch (error) {
        notification.error({
          message: translation.generalParameters.errorParameterUpdated,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [
      farmId,
      getParameters,
      groupId,
      translation.generalParameters.errorParameterUpdated,
      translation.generalParameters.successParameterUpdated,
    ]
  );

  const handleEdit = useCallback(
    (record) => {
      dispatch(
        BankAccountFarmActions.switchDrawerBankAccountFarmVisibility(record)
      );
    },
    [dispatch]
  );

  // const handleDelete = useCallback(async (id) => {
  //   try {
  //     // await destroy({ groupId, farmId, id });
  //     notification.success({
  //       message: "Projeto financeiro deletado com sucesso.",
  //     });
  //     // fetchData();
  //   } catch (error) {
  //     if (Object.keys(error).includes("response")) {
  //       const { response } = error;
  //       if (Object.keys(response).includes("data")) {
  //         const {
  //           data: { code: errorCode },
  //         } = response;
  //         if (errorCode === 5005) {
  //           notification.error({
  //             message: "Erro",
  //             description: `Este Projeto Financeiro não pode ser excluído, ele já está ligado a Movimentações Financeiras.`,
  //           });
  //         } else {
  //           notification.error({
  //             message: "Erro",
  //             description: "Erro ao deletar projeto financeiro.",
  //           });
  //         }
  //       }
  //     } else {
  //       notification.error({
  //         message: "Erro",
  //         description: "Erro ao deletar projeto financeiro.",
  //       });
  //     }
  //   } finally {
  //   }
  // }, []);

  const handleActivate = useCallback(
    async (id) => {
      try {
        await activateBankAccountFarm({ groupId, farmId, id });
        notification.success({
          message: translation.bankAccountFarm.messages.activateMessage,
        });
        fetchData();
      } catch (error) {
        notification.error({
          message: translation.bankAccountFarm.messages.errorMessage,
        });
      }
    },
    [
      groupId,
      farmId,
      translation.bankAccountFarm.messages.activateMessage,
      translation.bankAccountFarm.messages.errorMessage,
      fetchData,
    ]
  );

  const handleInactivate = useCallback(
    async (id) => {
      try {
        await inactivateBankAccountFarm({ groupId, farmId, id });
        notification.success({
          message: translation.bankAccountFarm.messages.inactivateMessage,
        });
        fetchData();
      } catch (error) {
        notification.error({
          message: translation.bankAccountFarm.messages.errorMessage,
        });
      }
    },
    [
      groupId,
      farmId,
      translation.bankAccountFarm.messages.inactivateMessage,
      translation.bankAccountFarm.messages.errorMessage,
      fetchData,
    ]
  );

  const handleSearch = useCallback((selectedKeys, confirm, dataIndex) => {
    confirm();
  }, []);

  const handleReset = useCallback((clearFilters) => {
    clearFilters();
  }, []);

  const handleGetColumnSearchProps = useCallback(
    (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon="search"
            size="small"
            style={{
              width: 90,
              marginRight: 8,
              background: "#684e94",
              borderColor: "none",
              border: "none",
            }}
          />
          <Button
            onClick={() => handleReset(clearFilters)}
            icon="delete"
            size="small"
            style={{ width: 90 }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#684e94" : undefined }}
        />
      ),
      onFilter: (value, record) => {
        if (dataIndex === "males") {
          return record[dataIndex]
            ?.map((m) => m.animalHandlingNumber.toLowerCase())
            .join(" ")
            .includes(value.toString().toLowerCase());
        } else {
          return record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value.toString().toLowerCase());
        }
      },
    }),
    [handleReset, handleSearch]
  );
  const handleGetColumnNumberSearchProps = useCallback(
    (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <div style={{ display: "block" }}>
            <Select
              value={
                selectedKeys
                  ? selectedKeys[0]?.type != null
                    ? selectedKeys[0]?.type
                    : "equal"
                  : "equal"
              }
              placeholder={translation.defaultSelectPlaceholder}
              onChange={(value) => {
                setSelectedKeys(
                  value
                    ? [{ ...selectedKeys[0], type: value }]
                    : [{ ...selectedKeys[0] }]
                );
              }}
            >
              <Select.Option value="equal">=</Select.Option>
              <Select.Option value="greaterThan">&gt;</Select.Option>
              <Select.Option value="greaterOrEqualThan">&ge;</Select.Option>
              <Select.Option value="lessThan">&lt;</Select.Option>
              <Select.Option value="lessOrEqualThan">&le;</Select.Option>
            </Select>
            <InputNumber
              value={
                selectedKeys
                  ? selectedKeys[0]?.value != null
                    ? selectedKeys[0]?.value
                    : null
                  : null
              }
              placeholder={translation.defaultSelectPlaceholder}
              onChange={(value) => {
                const operator =
                  selectedKeys && selectedKeys[0]
                    ? selectedKeys[0].type
                    : "equal";
                setSelectedKeys(
                  value
                    ? [
                        {
                          type: operator,
                          value: value,
                        },
                      ]
                    : [
                        {
                          type: operator,
                          value: null,
                        },
                      ]
                );
              }}
              onPressEnter={() => handleSearch(selectedKeys, confirm)}
              style={{ width: 90, marginBottom: 8 }}
              defaultValue={0}
              decimalSeparator=","
              min={-1000}
              max={1000}
              step={0.01}
              formatter={(value) => {
                if (value !== "") {
                  value = `${value}`.replace(/^-^[^0-9.,]*/g, "");
                  value = value.replace(/\.{2,}/g, ".");
                  value = value.replace(/\.,/g, ",");
                  value = value.replace(/,\./g, ",");
                  value = value.replace(/,{2,}/g, ",");
                  value = value.replace(/\.[0-9]+\./g, ".");
                  value =
                    value.split(".")[1] !== "" &&
                    value.split(".")[1] !== undefined
                      ? value.split(".")[0] +
                        "." +
                        value.split(".")[1].substring(0, 2)
                      : value;
                }
                return value;
              }}
            />
          </div>
          <div>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm)}
              icon="search"
              size="small"
              style={{
                width: 90,
                marginRight: 8,
                background: "#684e94",
                borderColor: "none",
                border: "none",
              }}
            />
            <Button
              onClick={() => handleReset(clearFilters)}
              icon="delete"
              size="small"
              style={{ width: 90 }}
            />
          </div>
        </div>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#684e94" : undefined }}
        />
      ),
      onFilter: (value, record) => {
        switch (value?.type) {
          case "equal":
            return getTwoDecimalDigits(record[dataIndex]) === value?.value;
          case "lessOrEqualThan":
            return getTwoDecimalDigits(record[dataIndex]) <= value?.value;
          case "lessThan":
            return getTwoDecimalDigits(record[dataIndex]) < value?.value;
          case "greaterOrEqualThan":
            return getTwoDecimalDigits(record[dataIndex]) >= value?.value;
          case "greaterThan":
            return getTwoDecimalDigits(record[dataIndex]) > value?.value;
          default:
            return getTwoDecimalDigits(record[dataIndex]) === value?.value;
        }
      },
    }),
    [handleReset, handleSearch, translation.defaultSelectPlaceholder]
  );

  const handleOpenDrawer = () => {
    dispatch(BankAccountFarmActions.switchDrawerBankAccountFarmVisibility());
  };

  const menu = (id, record) => {
    return (
      <Menu>
        {record.status === "Active" && (
          <Menu.Item onClick={() => handleEdit(record)}>
            {translation.table.menu.edit}
          </Menu.Item>
        )}
        {record.status === "Active" && (
          <Menu.Item onClick={() => handleInactivate(id)}>
            {translation.table.menu.inactivate}
          </Menu.Item>
        )}
        {record.status === "Inactive" && (
          <Menu.Item onClick={() => handleActivate(id)}>
            {translation.table.menu.activate}
          </Menu.Item>
        )}
      </Menu>
    );
  };

  useEffect(() => {
    let doFetch = true;
    if (doFetch) {
      getParameters();
      doFetch = false;
    }
    return () => {
      doFetch = true;
    };
  }, [groupId, farmId, getParameters]);

  useEffect(() => {
    if (parametersValue.length > 0) {
      setParameter4006Value(
        parametersValue.find((parameter) => parameter.code === 4006)
      );
    }
  }, [parametersValue]);

  useEffect(() => {
    let doFetch = true;
    if (doFetch) {
      fetchData();
      doFetch = false;
    }

    return () => {
      doFetch = true;
    };
  }, [fetchData]);

  return (
    <CardCustom>
      <Spin spinning={isLoading}>
        <Row type="flex" align="middle" gutter={16}>
          {/* Parameter 4006 */}
          <Col>
            <Row type="flex" justify="center" align="middle" gutter={16}>
              <Col>
                <label htmlFor="parameter4006Value">
                  {translation.bankAccountFarm.parameter4006}
                </label>
              </Col>
              <Col>
                <Switch
                  id="parameter4006Value"
                  checked={
                    parameter4006Value && parameter4006Value?.value === "true"
                      ? true
                      : false
                  }
                  onChange={(checked) =>
                    handleChangeParameter4006Value(parameter4006Value, checked)
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <TableContainer
          isActive={parameter4006Value?.value === "true" ? true : false}
        >
          <Row className="rowHeader" justify="space-between">
            <Col span={8}>
              <Title>{translation.bankAccountFarm.title}</Title>
            </Col>
            <Col span={16}>
              <Row type="flex" justify="end" gutter={8}>
                <Col>
                  <ButtonStandard
                    buttonType="typeWithoutBackground"
                    onClick={fetchData}
                  >
                    <Icon type="reload" />
                  </ButtonStandard>
                </Col>
                <Col>
                  <ButtonStandard buttonType="addNew" onClick={handleOpenDrawer}>
                    {translation.bankAccountFarm.buttonNew}
                  </ButtonStandard>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={24}>
              <Table
                loading={isLoadingDataList}
                rowKey="id"
                size="small"
                dataSource={dataList}
                pagination={{
                  hideOnSinglePage:
                    dataList !== null && dataList.length > 10 ? false : true,
                  showSizeChanger: true,
                  pageSizeOptions: [
                    "10",
                    "20",
                    "30",
                    "100",
                    "500",
                    "1000",
                    "2000",
                  ],
                }}
              >
                <Table.Column
                  title={translation.bankAccountFarm.table.columns.status}
                  dataIndex="status"
                  key="status"
                  align="left"
                  sorter={(first, second) => {
                    return first.status.localeCompare(second.status, "pt-BR", {
                      numeric: false,
                      ignorePunctuation: true,
                    });
                  }}
                  defaultFilteredValue={["Active"]}
                  filtered
                  filters={[
                    {
                      text: translation.status.active,
                      value: "Active",
                    },
                    {
                      text: translation.status.inactive,
                      value: "Inactive",
                    },
                  ]}
                  filterMultiple
                  onFilter={(value, record) => record.status.includes(value)}
                  render={(status) =>
                    status === "Active" ? (
                      <TagStatus
                        background="#C5F1CA"
                        borderColor="#106518"
                        color="#106518"
                      >
                        {translation.status.active}
                      </TagStatus>
                    ) : (
                      <TagStatus
                        background="#FBC7C7"
                        borderColor="#D44C4C"
                        color="#D44C4C"
                      >
                        {translation.status.inactive}
                      </TagStatus>
                    )
                  }
                />
                <Table.Column
                  title={translation.bankAccountFarm.table.columns.description}
                  dataIndex="description"
                  sorter={(first, second) => {
                    if (!first.description) {
                      first.description = "";
                    }
                    return first.description.localeCompare(
                      second.description,
                      "pt-BR",
                      {
                        numeric: false,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="description"
                  {...handleGetColumnSearchProps("description")}
                />
                <Table.Column
                  title={translation.bankAccountFarm.table.columns.bankName}
                  dataIndex="bankName"
                  sorter={(first, second) => {
                    if (!first.bankName) {
                      first.bankName = "";
                    }
                    return first.bankName.localeCompare(
                      second.bankName,
                      "pt-BR",
                      {
                        numeric: false,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="bankName"
                  {...handleGetColumnSearchProps("bankName")}
                />
                <Table.Column
                  title={translation.bankAccountFarm.table.columns.bankCode}
                  dataIndex="bankCode"
                  sorter={(first, second) => {
                    if (!first.bankCode) {
                      first.bankCode = "";
                    }
                    return first.bankCode.localeCompare(
                      second.bankCode,
                      "pt-BR",
                      {
                        numeric: false,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="bankCode"
                  {...handleGetColumnSearchProps("bankCode")}
                  render={(text) => String(text).padStart(3, "0")}
                />
                <Table.Column
                  title={
                    translation.bankAccountFarm.table.columns.bankAccountNumber
                  }
                  dataIndex="bankAccountNumber"
                  sorter={(first, second) => {
                    if (!first.bankAccountNumber) {
                      first.bankAccountNumber = "";
                    }
                    return first.bankAccountNumber.localeCompare(
                      second.bankAccountNumber,
                      "pt-BR",
                      {
                        numeric: false,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="bankAccountNumber"
                  {...handleGetColumnSearchProps("bankAccountNumber")}
                />
                <Table.Column
                  title={
                    translation.bankAccountFarm.table.columns.bankAgencyNumber
                  }
                  dataIndex="bankAgencyNumber"
                  sorter={(first, second) => {
                    if (!first.bankAgencyNumber) {
                      first.bankAgencyNumber = "";
                    }
                    return first.bankAgencyNumber.localeCompare(
                      second.bankAgencyNumber,
                      "pt-BR",
                      {
                        numeric: false,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="bankAgencyNumber"
                  {...handleGetColumnSearchProps("bankAgencyNumber")}
                />
                <Table.Column
                  title={
                    translation.bankAccountFarm.table.columns.initialBalance
                  }
                  dataIndex="initialBalance"
                  sorter={(first, second) => {
                    if (!first.initialBalance) {
                      first.initialBalance = 0;
                    }
                    return first.initialBalance.localeCompare(
                      second.initialBalance,
                      "pt-BR",
                      {
                        numeric: true,
                        ignorePunctuation: true,
                      }
                    );
                  }}
                  key="initialBalance"
                  {...handleGetColumnNumberSearchProps("initialBalance")}
                  render={(text, record) => {
                    return numberMask(record.initialBalance, true);
                  }}
                />
                <Table.Column
                  title=""
                  align="left"
                  render={(text, record) => (
                    <Dropdown
                      overlay={menu(record.id, record)}
                      trigger={["click"]}
                      key={record.id}
                    >
                      <MenuContainer>
                        <MenuIcon />
                      </MenuContainer>
                    </Dropdown>
                  )}
                />
              </Table>
            </Col>
          </Row>
        </TableContainer>
      </Spin>
      <DrawerBankAccountFarm />
    </CardCustom>
  );
}

export default BankAccountFarm;
